import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderFailedOwnProps, OrderFailedProps, OrderFailedRuntimeProps} from './interfaces'
import {OrderFailed as Presentation} from './order-failed'

const mapRuntimeToProps = ({actions: {navigateToDetails}}: DetailsPageAppProps): OrderFailedProps => ({
  navigateToDetails,
})

export const OrderFailed = connect<OrderFailedOwnProps, OrderFailedRuntimeProps>(mapRuntimeToProps)(Presentation)
